import styled from "styled-components";

export const CmpSelect = styled.div`
`;
